module.exports = __webpack_public_path__ + "img/wf-finishing-position-30.b54d55e4.svg";